import { Component, OnInit, ViewChild, forwardRef } from "@angular/core";
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  ControlContainer,
} from "@angular/forms";
import { mergeMap, switchMap } from "rxjs/operators";
import { Observable } from "rxjs";
import { TypeaheadMatch } from "ngx-bootstrap";
import { AttoWrapperDTO } from "@app/shared/dto/attoWrapperDTO";
import { FiltroRicercaAttoVO } from "@app/shared/vo/filtro-ricerca-attoVO";
import { AttoService } from "@app/shared/services/atto.service";
import { PaginazioneVO } from "@app/shared/vo/paginazioneVO";
import { OrdinamentoVO } from "@app/shared/vo/ordinamentoVO";
import { AttoWrapperVO } from "@app/shared/vo/attoWrapperVO";
import { ResultListVO } from "@app/shared/vo/resultList.vo";
import { AttoVO } from "@app/shared/vo/attoVO";
import { StatoAttoEnum } from "@app/shared/enum/stato-atto-enum";
import { TipologiaDecretoEnum } from "@app/shared/enum/tipologia-decreto-enum";
import { ModaleAggiungiDatiDecretoComponent } from "../modale-aggiungi-dati-decreto/modale-aggiungi-dati-decreto.component";
import { DatiDecretoManualiVO } from "@app/shared/vo/dati-decreto-manualiVO";
import { MetadatiRepertorioVO } from "@app/shared/vo/metadati-repertorioVO";

@Component({
  selector: "app-typeahead-ricerca-decreti",
  templateUrl: "./type-ahead-ricerca-decreti.component.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TypeAheadRicercaDecretiComponent),
      multi: true,
    },
  ],
})
export class TypeAheadRicercaDecretiComponent implements ControlValueAccessor, OnInit {
  public dataSourceDecreto: Observable<any>;
  public typeaheadLoadingDecreto: boolean;
  public typeaheadNoResultsDecreto: boolean;
  public asyncDecretoSelected: string;

  listaDecretiSelezionati: AttoWrapperDTO[] = [];

  public decretoBool: boolean = false;

  selectedDecreto: string;

  erroreDecreto: boolean;
  erroreDecretoTesto: string;


  @ViewChild("modaleAggiungiDatiDecreto", { static: false })
  public modaleAggiungiDatiDecreto: ModaleAggiungiDatiDecretoComponent;

  public value;
  public formGroup;
  public idFascicolo: string;

  constructor(
    private attoService: AttoService,
    private controlContainer: ControlContainer,
  ) {
    let filtro: FiltroRicercaAttoVO = new FiltroRicercaAttoVO();
    filtro.limitazioniVisibilita = false;
    filtro.stato = StatoAttoEnum.PUBBLICATO;
    filtro.pageNumber = 0;
    filtro.tipologiaDecreto = TipologiaDecretoEnum.DECRETO_CONTABILE;
    let paginazione: PaginazioneVO = new PaginazioneVO();
    paginazione.pageNumber = 0;
    paginazione.size = 100;

    let ordinamento: OrdinamentoVO = new OrdinamentoVO();

    ordinamento.elemento = "dataApertura";
    ordinamento.direzione = 0;

    //fascicoli collegati
    this.dataSourceDecreto = Observable.create((observer: any) => {
      // Runs on every search
      observer.next(this.asyncDecretoSelected);
    }).pipe(
      switchMap((value: string) =>
        this.eseguiRicerca(String(value), filtro, paginazione, ordinamento)
      ));
  }

  private eseguiRicerca(textSearch: string, filtro: FiltroRicercaAttoVO, paginazione: PaginazioneVO, ordinamento: OrdinamentoVO): Observable<AttoVO[]> {
    filtro.textSearch = textSearch;
    return this.attoService.ricercaAvanzata(filtro, false, paginazione, ordinamento).map(
      res => res.resultList
    );
  }

  onChange: any = () => { };
  onTouched: any = () => { };

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(value) {
    this.value = value;
  }



  onSelect(ev) {
    console.log(ev.item);
    //let the formControl know the value's been changed
    this.onChange(ev.item);
    this.onTouched();
  }

  onBlur() {
    //let the formControl know it's been touched
    this.onTouched();
  }

  ngOnInit() {
    this.formGroup = this.controlContainer.control;

  }

  public changeTypeaheadLoadingDecreto(e: boolean): void {
    this.typeaheadLoadingDecreto = e;
  }

  public changeTypeaheadNoResultsDecreto(e: boolean): void {
    this.decretoBool = true;
    this.typeaheadNoResultsDecreto = e;
  }

  public typeaheadOnSelectDecreto(e: TypeaheadMatch): void {
    this.erroreDecreto = false;
    this.erroreDecretoTesto = "";
    const decreteSelect = new AttoVO();
    decreteSelect.id = e.item.id;
    decreteSelect.oggetto = e.item.oggetto;
    decreteSelect.metadatiRepertorio = e.item.metadatiRepertorio;
    decreteSelect.dataConclusione = e.item.dataConclusione;

    this.formGroup.get("decreto").setValue(decreteSelect);
  }

  public rimuoviDecreto() {
    this.formGroup.get("decreto").reset();

    this.formGroup.updateValueAndValidity({
      onlySelf: false,
      emitEvent: true,
    });
  }

  confermaDatiDecreto(datiDecreto: DatiDecretoManualiVO) {
    const decreteSelect = new AttoVO();
    decreteSelect.oggetto = datiDecreto.oggetto;
    decreteSelect.metadatiRepertorio = new MetadatiRepertorioVO();
    decreteSelect.dataConclusione = datiDecreto.dataConclusione;
    decreteSelect.metadatiRepertorio.numero = datiDecreto.numero;
    decreteSelect.metadatiRepertorio.data = datiDecreto.dataConclusione;
    decreteSelect.metadatiRepertorio.segnatura = datiDecreto.segnatura;


    this.formGroup.get("decreto").setValue(decreteSelect);
    this.formGroup.updateValueAndValidity({
      onlySelf: false,
      emitEvent: true,
    });
  }


  aggiungi() {
    this.modaleAggiungiDatiDecreto.openModal();
  }
}
